import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

const CONSENT_STORAGE_KEY = "welephant_consent_accepted"
const CONSENT_VERSION = "1" // Increment to re-prompt users if TOS changes

function hasAcceptedConsent(): boolean {
  if (typeof window === "undefined") return false
  const stored = localStorage.getItem(CONSENT_STORAGE_KEY)
  return stored === CONSENT_VERSION
}

function saveConsent(): void {
  if (typeof window !== "undefined") {
    localStorage.setItem(CONSENT_STORAGE_KEY, CONSENT_VERSION)
  }
}

export function ConsentModal() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    // Show modal if consent not yet given
    if (!hasAcceptedConsent()) {
      setOpen(true)
    }
  }, [])

  const handleAccept = () => {
    saveConsent()
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-md"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Welcome to Welephant</DialogTitle>
          <DialogDescription>
            Please review and accept our terms before continuing.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4 space-y-4">
          <p className="text-sm text-muted-foreground">
            By using this site, you acknowledge that you have read, understood, and agree to be bound by our Terms of Service and Privacy Policy.
          </p>

          <p className="text-sm text-muted-foreground">
            This site uses cookies and local storage to remember your preferences and provide a better experience.
          </p>

          <div className="flex flex-col gap-2 text-sm">
            <Link
              to="/terms"
              className="text-primary hover:underline"
              onClick={(e) => {
                // Allow opening in new tab
                if (!e.ctrlKey && !e.metaKey) {
                  e.preventDefault()
                  window.open("/terms", "_blank")
                }
              }}
            >
              Terms of Service
            </Link>
            <Link
              to="/privacy"
              className="text-primary hover:underline"
              onClick={(e) => {
                if (!e.ctrlKey && !e.metaKey) {
                  e.preventDefault()
                  window.open("/privacy", "_blank")
                }
              }}
            >
              Privacy Policy
            </Link>
          </div>
        </div>

        <DialogFooter>
          <Button onClick={handleAccept} className="w-full">
            I Accept
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
